export interface GlobalSearch {
  accountSelected?: boolean
  accountSelectionRequired?: boolean
  searchMethod?: string
  searchResult?: string
  searchResultCategory?: string
  searchTerm?: string
  searchType?: string
}

export const SEARCH_METHOD_TEXT_INPUT = 'searchbar'
export const SEARCH_TYPE_GLOBAL = 'globalsearch'

export const MAX_SEARCH_TERM_LENGTH = 100
export const REDACTED = '[redacted]'

// Any digit (card #, phone, SSN, DOB, account #) or '@' (email) is treated as potential PII.
export const sanitizeSearchTerm = (raw: string): string => {
  if (/[\d@]/.test(raw)) return REDACTED
  return raw.trim().slice(0, MAX_SEARCH_TERM_LENGTH)
}

declare global {
  interface SFDDL {
    globalSearch?: GlobalSearch
  }
}

export const updateGlobalSearch = (attributes: GlobalSearch): void => {
  const { _SFDDL: sfddl } = window
  if (!sfddl) return

  sfddl.globalSearch = {
    ...sfddl.globalSearch,
    ...attributes
  }
}

export const resetGlobalSearch = (): void => {
  const { _SFDDL: sfddl } = window
  if (!sfddl) return
  sfddl.globalSearch = {}
}
